import { Capacitor } from '@capacitor/core';

export const ANDROID_APP_ID = 'com.dqlogix.digiqin';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function isNativeAndroid() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

export async function getAndroidVersionCode() {
  if (!isNativeAndroid()) {
    return null;
  }

  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    const build = parseInt(info.build, 10);
    return Number.isFinite(build) ? build : null;
  } catch (error) {
    console.warn('Unable to read native app version:', error);
    return null;
  }
}

export function getPlayStoreUrl(override) {
  if (override) {
    return override;
  }

  return (
    process.env.REACT_APP_ANDROID_PLAY_STORE_URL
    || `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}`
  );
}

export function openPlayStore(playStoreUrl) {
  const webUrl = getPlayStoreUrl(playStoreUrl);
  const marketUrl = `market://details?id=${ANDROID_APP_ID}`;

  if (isNativeAndroid()) {
    window.location.href = marketUrl;
    window.setTimeout(() => {
      window.location.href = webUrl;
    }, 600);
    return;
  }

  window.open(webUrl, '_blank', 'noopener,noreferrer');
}
